'use client'

import { ComponentSpinner } from '@tebuto/layout/Spinner'
import { cn } from '@tebuto/lib/utils'
import type { ReactNode } from 'react'

export interface PayPalOfflineMethodRowProps {
    label: string
    selected: boolean
    icon?: ReactNode
    disabled?: boolean
    loading?: boolean
    onSelect: () => void
    testId: string
}

export function PayPalOfflineMethodRow({
    label,
    selected,
    icon,
    disabled = false,
    loading = false,
    onSelect,
    testId
}: PayPalOfflineMethodRowProps) {
    const isDisabled = disabled || loading

    return (
        <button
            type="button"
            data-testid={testId}
            onClick={onSelect}
            disabled={isDisabled}
            className={cn(
                'widget-paypal-offline-row-card',
                selected && 'widget-paypal-offline-row-card--selected',
                isDisabled && 'opacity-50'
            )}
        >
            <span
                className={cn(
                    'widget-paypal-offline-row',
                    selected && 'widget-paypal-offline-row--selected',
                    isDisabled && 'cursor-not-allowed'
                )}
            >
                {icon ? <span className="widget-paypal-offline-row__icon">{icon}</span> : null}
                <span className="widget-paypal-offline-row__label">{label}</span>
                {loading ? <ComponentSpinner className="size-5 widget-text-secondary" /> : null}
            </span>
        </button>
    )
}
